var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-col',_vm._g(_vm._b({staticClass:"col",class:{ 'auto-size': _vm.autoSize, 'fixed-size': _vm.size },attrs:{"lg":_vm.lg,"md":_vm.md,"offset":_vm.offset,"order":_vm.order,"pull":_vm.pull,"push":_vm.push,"sm":_vm.sm,"span":_vm.size,"xl":_vm.xl,"xs":_vm.xs,"xxl":_vm.xxl}},'a-col',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }